import { makeRequest, buildResponse, buildError } from 'helpers/requestHandler'

export default class StationBank {

	view(id = null, key) {
		return new Promise((resolve, reject) => {
			makeRequest('/timetables/bank/view', 'POST', {
				'key': key,
				'id' : id
			}).then((response) => {
				if(response.ok) {
					response.json().then((json) => {
						this.name = json.name
						this.id = json.id
						this.locations = json.locations
						this.user = json.user
						resolve(buildResponse(true, json))
					})
				} else {
					switch (response.status){
						case 403:
							return buildError(response, reject, 'Not enough permissions to perform operation')
						case 404:
							return buildError(response, reject, 'Station Bank does not exist')
						default:
							return buildError(response, reject, 'Unknown')
					}
				}
			})
		})
	}

	create(locations, key) {
		return new Promise((resolve, reject) => {
			makeRequest('/timetables/bank/create', 'POST', {
				'key': key,
				'locations': locations,
				'name': `${locations[0].displayName} to ${locations[locations.length-1].displayName}`
			}).then((response) => {
				if(response.ok){
					response.json().then((json) => resolve(buildResponse(true, json)))
				} else {
					switch (response.status){
						case 403:
							return buildError(response, reject, 'Not enough permissions to perform operation')
						case 409:
							return buildError(response, reject, 'The requested name already exists')
						default:
							return buildError(response, reject, 'Unknown')
					}
				}
			})
		})
	}

	list(key) {
		return new Promise((resolve, reject) => {
			makeRequest('/timetables/bank/list', 'POST', {
				'key' : key
			}).then((response) => {
				if(response.ok) {
					response.json().then((json) => resolve(buildResponse(true, json)))
				} else {
					switch (response.status){
						case 403:
							return buildError(response, reject, 'Not enough permissions to perform operation')
						case 206:
							return buildError(response, reject, 'No valid tables')
						default:
							return buildError(response, reject, 'Unknown')
					}
				}
			})
		})
	}

	edit(id, name, locations, key) {
		return new Promise((resolve, reject) => {
			makeRequest('/timetables/bank/edit', 'POST', {
				'key'      : key,
				'id'       : id,
				'name'     : name,
				'locations': locations
			}).then((response) => {
				if(response.ok) {
					response.json().then((json) => resolve(buildResponse(true, json)))
				} else {
					switch (response.status){
						case 403:
							return buildError(response, reject, 'Not enough permissions to perform operation')
						case 409:
							return buildError(response, reject, 'The requested name already exists')
						default:
							return buildError(response, reject, 'Unknown')
					}
				}
			})
		})
	}

	delete(id, key){
		return new Promise((resolve, reject) => {
			makeRequest('/timetables/bank/delete', 'POST', {
				'key'      : key,
				'id'       : id,
			}).then((response) => {
				if(response.ok) {
					response.json().then((json) => resolve(buildResponse(true, json)))
				} else {
					switch (response.status){
						case 403:
							return buildError(response, reject, 'Not enough permissions to perform operation')
						case 409:
							return buildError(response, reject, 'The requested name already exists')
						default:
							return buildError(response, reject, 'Unknown')
					}
				}
			})
		})
	}

	reverse(id, name, key) {
		return new Promise((resolve, reject) => {
			makeRequest('/timetables/bank/reverse', 'POST', {
				'key'		: key,
				'base_id'	: id,
				'name'		: name
			}).then(response => {
				if (response.ok) {
					response.json().then(json => resolve(buildResponse(true, json)))
				} else {
					switch (response.status){
						case 400:
							return buildError(response, reject, 'Cannot edit this bank as not staff/not the bank creator')
						case 403:
							return buildError(response, reject, 'User not logged in or not authorised to create new content')
						case 404:
							return buildError(response, reject, 'Station bank does nto exist')
						case 409:
							return buildError(response, reject, 'Requested name already exists')
						default:
							return buildError(response, reject, 'Unknown')
					}
				}
			})
		})
	}

	filters = {
		callingpoint: {
			list: (bank, key) => {
				return new Promise((resolve, reject) => {
					makeRequest('/timetables/bank/filters/list', 'POST', {
						'key'      : key,
						'bank_id'  : bank.id,
					}).then((response) => {
						if(response.ok) {
							response.json().then((json) => resolve(buildResponse(true, json)))
						} else {
							switch (response.status){
								case 404:
									return buildError(response, reject, 'No filters available')
								case 400:
									return buildError(response, reject, 'Missing fields')
								default:
									return buildError(response, reject, 'Unknown')
							}
						}
					})
				})
			},
			view: (bank, filter, key) => {
				return new Promise((resolve, reject) => {
					makeRequest('/timetables/bank/filters/list', 'POST', {
						'key'      : key,
						'bank_id'  : bank.id,
						'filter_id': filter
					}).then((response) => {
						if(response.ok) {
							response.json().then((json) => resolve(buildResponse(true, json)))
						} else {
							switch (response.status){
								case 404:
									return buildError(response, reject, 'Filter not available')
								case 400:
									return buildError(response, reject, 'Missing fields')
								default:
									return buildError(response, reject, 'Unknown')
							}
						}
					})
				})
			},
			create: (bank, locations, name, key) => {
				return new Promise((resolve, reject) => {
					makeRequest('/timetables/bank/filters/create', 'POST', {
						'key'      : key,
						'bank_id'  : bank.id,
						'locations': locations,
						'name': name
					}).then((response) => {
						if(response.ok) {
							response.json().then((json) => resolve(buildResponse(true, json)))
						} else {
							switch (response.status){
								case 400:
									return buildError(response, reject, 'Locations missing')
								default:
									return buildError(response, reject, 'Unknown')
							}
						}
					})
				})
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/thunks/classes/StationBank.js